import { Diagnosis } from '../hypothesis'
import { isEqual } from 'lodash'

export default [
  {
    /** @type {Diagnosis} */
    diagnosis(answers) {
      const answerMap = {
        '[não colocar texto]': [
          ['sim', 'sim', 'nao-disponivel'],
          ['sim', 'nao', 'nao-disponivel'],
          ['sim', 'nao-disponivel', 'nao-disponivel'],
          ['nao', 'sim', 'nao-disponivel'],
          ['nao', 'nao', 'nao-disponivel'],
          ['nao', 'nao-disponivel', '30-1500'],
          ['nao', 'nao-disponivel', 'nao-disponivel'],
          ['nao-disponivel', 'nao', '30-1500'],
          ['nao-disponivel', 'nao', 'nao-disponivel'],
          ['nao-disponivel', 'sim', 'nao-disponivel'], // Rever
          ['nao-disponivel', 'nao-disponivel', '30-1500'],
          ['nao-disponivel', 'nao-disponivel', 'nao-disponivel'],
        ],
        alérgica: [
          ['sim', 'sim', '30-1500'],
          ['sim', 'nao', '30-1500'],
          ['sim', 'nao-disponivel', '30-1500'],
          ['nao', 'sim', '30-1500'],
          ['nao', 'nao', '30-1500'],
          ['nao-disponivel', 'sim', '30-1500'],
        ],
        'não alérgica': [
          ['sim', 'sim', '<30'],
          ['sim', 'nao', '<30'],
          ['sim', 'nao-disponivel', '<30'],
          ['nao', 'sim', '<30'],
          ['nao', 'nao', '<30'],
          ['nao', 'nao-disponivel', '<30'],
          ['nao-disponivel', 'sim', '<30'],
          ['nao-disponivel', 'nao', '<30'],
          ['nao-disponivel', 'nao-disponivel', '<30'],
        ],
      }

      /** @type {[string, string[]][]} */
      const flatAnswersEntries = Object.entries(answerMap).flatMap(([diagnosis, answers]) =>
        answers.map((answer) => [diagnosis, answer]),
      )

      const resArray = [answers['35'], answers['36'], answers['37']]
      for (let [diagnosis, answer] of flatAnswersEntries) {
        if (isEqual(resArray, answer)) {
          return {
            text: diagnosis == '[não colocar texto]' ? undefined : diagnosis,
            proceed: false,
          }
        }
      }

      return {
        proceed: false,
      }
    },
    version: {
      /** @type {number[]} */
      include: [],
      /** @type {number[]} */
      exclude: [],
    },
  },
]
